<app-simple-modal-header
	[pageTitle]="primaryAttributeName"
	(dismissed)="dismiss()"
>
	<ion-item>
		<ion-searchbar
			(input)="onChangeFilter($event.target.value)"
		></ion-searchbar>
	</ion-item>
</app-simple-modal-header>

<ion-content>
	<ion-list lines="full" *ngIf="attributes.length > 0; else empty">
		<ion-item
			*ngFor="let attribute of attributes"
			button
			(click)="dismiss(attribute)"
		>
			<ion-text>{{ attribute.value }}</ion-text>
		</ion-item>
	</ion-list>

	<ng-template #empty>
		<app-empty-list-item
			message="No inventory available"
		></app-empty-list-item>
	</ng-template>
</ion-content>
